import { render, staticRenderFns } from "./StudioHomeTemplateBrandColor.vue?vue&type=template&id=3702169a&scoped=true&"
import script from "./StudioHomeTemplateBrandColor.vue?vue&type=script&lang=js&"
export * from "./StudioHomeTemplateBrandColor.vue?vue&type=script&lang=js&"
import style0 from "./StudioHomeTemplateBrandColor.vue?vue&type=style&index=0&id=3702169a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702169a",
  null
  
)

export default component.exports